import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimezoneConverterService {

  private readonly timezoneMapping: { [key: string]: string } = {
    // Common timezone codes
    'IST': '(GMT+05:30) India Standard Time (Asia/Kolkata)',
    'GMT': '(GMT+00:00) Greenwich Mean Time (Europe/London)',
    'UTC': '(GMT+00:00) Coordinated Universal Time (UTC)',
    'EST': '(GMT-05:00) Eastern Standard Time (America/New_York)',
    'PST': '(GMT-08:00) Pacific Standard Time (America/Los_Angeles)',
    'CST': '(GMT-06:00) Central Standard Time (America/Chicago)',
    'MST': '(GMT-07:00) Mountain Standard Time (America/Denver)',
    'CET': '(GMT+01:00) Central European Time (Europe/Berlin)',
    'EET': '(GMT+02:00) Eastern European Time (Europe/Athens)',
    'WET': '(GMT+00:00) Western European Time (Europe/Lisbon)',
    'WAT': '(GMT+01:00) West Africa Time (Africa/Lagos)',
    'EAT': '(GMT+03:00) East Africa Time (Africa/Nairobi)',
    'CAT': '(GMT+02:00) Central Africa Time (Africa/Harare)',
    'SAST': '(GMT+02:00) South Africa Standard Time (Africa/Johannesburg)',
    'JST': '(GMT+09:00) Japan Standard Time (Asia/Tokyo)',
    'KST': '(GMT+09:00) Korea Standard Time (Asia/Seoul)',
    'SGT': '(GMT+08:00) Singapore Time (Asia/Singapore)',
    'MYT': '(GMT+08:00) Malaysia Time (Asia/Kuala_Lumpur)',
    'PHT': '(GMT+08:00) Philippine Time (Asia/Manila)',
    'ICT': '(GMT+07:00) Indochina Time (Asia/Bangkok)',
    'WIB': '(GMT+07:00) Western Indonesia Time (Asia/Jakarta)',
    'WITA': '(GMT+08:00) Central Indonesia Time (Asia/Makassar)',
    'WIT': '(GMT+09:00) Eastern Indonesia Time (Asia/Jayapura)',
    'AEST': '(GMT+10:00) Australian Eastern Standard Time (Australia/Sydney)',
    'ACST': '(GMT+09:30) Australian Central Standard Time (Australia/Adelaide)',
    'AWST': '(GMT+08:00) Australian Western Standard Time (Australia/Perth)',
    'NZST': '(GMT+12:00) New Zealand Standard Time (Pacific/Auckland)',
    'GST': '(GMT+04:00) Gulf Standard Time (Asia/Dubai)',
    'AST': '(GMT+03:00) Arabia Standard Time (Asia/Riyadh)',
    'MSK': '(GMT+03:00) Moscow Standard Time (Europe/Moscow)',
    'TRT': '(GMT+03:00) Turkey Time (Europe/Istanbul)',
    'IRST': '(GMT+03:30) Iran Standard Time (Asia/Tehran)',
    'PKT': '(GMT+05:00) Pakistan Standard Time (Asia/Karachi)',
    'BDT': '(GMT+06:00) Bangladesh Standard Time (Asia/Dhaka)',
    'NPT': '(GMT+05:45) Nepal Time (Asia/Kathmandu)',
    'SLST': '(GMT+05:30) Sri Lanka Standard Time (Asia/Colombo)',
    'MVT': '(GMT+05:00) Maldives Time (Indian/Maldives)',
    'BTT': '(GMT+06:00) Bhutan Time (Asia/Thimphu)',
    'MMT': '(GMT+06:30) Myanmar Time (Asia/Yangon)',
    'TLT': '(GMT+09:00) East Timor Time (Asia/Dili)',
    'PWT': '(GMT+09:00) Palau Time (Pacific/Palau)',
    'CHUT': '(GMT+10:00) Chuuk Time (Pacific/Chuuk)',
    'PGT': '(GMT+10:00) Papua New Guinea Time (Pacific/Port_Moresby)',
    'SBT': '(GMT+11:00) Solomon Islands Time (Pacific/Guadalcanal)',
    'VUT': '(GMT+11:00) Vanuatu Time (Pacific/Efate)',
    'NCT': '(GMT+11:00) New Caledonia Time (Pacific/Noumea)',
    'FJT': '(GMT+12:00) Fiji Time (Pacific/Fiji)',
    'TVT': '(GMT+12:00) Tuvalu Time (Pacific/Funafuti)',
    'WFT': '(GMT+12:00) Wallis and Futuna Time (Pacific/Wallis)',
    'TOT': '(GMT+13:00) Tonga Time (Pacific/Tongatapu)',
    'CHAST': '(GMT+12:45) Chatham Standard Time (Pacific/Chatham)',
    'LINT': '(GMT+14:00) Line Islands Time (Pacific/Kiritimati)',
    'HST': '(GMT-10:00) Hawaii Standard Time (Pacific/Honolulu)',
    'AKST': '(GMT-09:00) Alaska Standard Time (America/Anchorage)',
    
    // Full timezone identifiers
    'Asia/Kolkata': '(GMT+05:30) India Standard Time (Asia/Kolkata)',
    'Asia/Dubai': '(GMT+04:00) Gulf Standard Time (Asia/Dubai)',
    'Asia/Tokyo': '(GMT+09:00) Japan Standard Time (Asia/Tokyo)',
    'Asia/Shanghai': '(GMT+08:00) China Standard Time (Asia/Shanghai)',
    'Asia/Seoul': '(GMT+09:00) Korea Standard Time (Asia/Seoul)',
    'Asia/Singapore': '(GMT+08:00) Singapore Time (Asia/Singapore)',
    'Asia/Kuala_Lumpur': '(GMT+08:00) Malaysia Time (Asia/Kuala_Lumpur)',
    'Asia/Manila': '(GMT+08:00) Philippine Time (Asia/Manila)',
    'Asia/Bangkok': '(GMT+07:00) Indochina Time (Asia/Bangkok)',
    'Asia/Jakarta': '(GMT+07:00) Western Indonesia Time (Asia/Jakarta)',
    'Asia/Makassar': '(GMT+08:00) Central Indonesia Time (Asia/Makassar)',
    'Asia/Jayapura': '(GMT+09:00) Eastern Indonesia Time (Asia/Jayapura)',
    'Asia/Karachi': '(GMT+05:00) Pakistan Standard Time (Asia/Karachi)',
    'Asia/Dhaka': '(GMT+06:00) Bangladesh Standard Time (Asia/Dhaka)',
    'Asia/Kathmandu': '(GMT+05:45) Nepal Time (Asia/Kathmandu)',
    'Asia/Colombo': '(GMT+05:30) Sri Lanka Standard Time (Asia/Colombo)',
    'Asia/Thimphu': '(GMT+06:00) Bhutan Time (Asia/Thimphu)',
    'Asia/Yangon': '(GMT+06:30) Myanmar Time (Asia/Yangon)',
    'Asia/Dili': '(GMT+09:00) East Timor Time (Asia/Dili)',
    'Asia/Riyadh': '(GMT+03:00) Arabia Standard Time (Asia/Riyadh)',
    'Asia/Tehran': '(GMT+03:30) Iran Standard Time (Asia/Tehran)',
    'Asia/Istanbul': '(GMT+03:00) Turkey Time (Europe/Istanbul)',
    'Asia/Moscow': '(GMT+03:00) Moscow Standard Time (Europe/Moscow)',
    'Europe/London': '(GMT+00:00) Greenwich Mean Time (Europe/London)',
    'Europe/Berlin': '(GMT+01:00) Central European Time (Europe/Berlin)',
    'Europe/Paris': '(GMT+01:00) Central European Time (Europe/Paris)',
    'Europe/Rome': '(GMT+01:00) Central European Time (Europe/Rome)',
    'Europe/Madrid': '(GMT+01:00) Central European Time (Europe/Madrid)',
    'Europe/Amsterdam': '(GMT+01:00) Central European Time (Europe/Amsterdam)',
    'Europe/Stockholm': '(GMT+01:00) Central European Time (Europe/Stockholm)',
    'Europe/Oslo': '(GMT+01:00) Central European Time (Europe/Oslo)',
    'Europe/Copenhagen': '(GMT+01:00) Central European Time (Europe/Copenhagen)',
    'Europe/Helsinki': '(GMT+02:00) Eastern European Time (Europe/Helsinki)',
    'Europe/Zurich': '(GMT+01:00) Central European Time (Europe/Zurich)',
    'Europe/Vienna': '(GMT+01:00) Central European Time (Europe/Vienna)',
    'Europe/Brussels': '(GMT+01:00) Central European Time (Europe/Brussels)',
    'Europe/Dublin': '(GMT+00:00) Greenwich Mean Time (Europe/Dublin)',
    'Europe/Athens': '(GMT+02:00) Eastern European Time (Europe/Athens)',
    'Europe/Lisbon': '(GMT+00:00) Western European Time (Europe/Lisbon)',
    'America/New_York': '(GMT-05:00) Eastern Standard Time (America/New_York)',
    'America/Los_Angeles': '(GMT-08:00) Pacific Standard Time (America/Los_Angeles)',
    'America/Chicago': '(GMT-06:00) Central Standard Time (America/Chicago)',
    'America/Denver': '(GMT-07:00) Mountain Standard Time (America/Denver)',
    'America/Toronto': '(GMT-05:00) Eastern Standard Time (America/Toronto)',
    'America/Vancouver': '(GMT-08:00) Pacific Standard Time (America/Vancouver)',
    'America/Montreal': '(GMT-05:00) Eastern Standard Time (America/Montreal)',
    'America/Mexico_City': '(GMT-06:00) Central Standard Time (America/Mexico_City)',
    'America/Sao_Paulo': '(GMT-03:00) Brasilia Standard Time (America/Sao_Paulo)',
    'America/Buenos_Aires': '(GMT-03:00) Argentina Standard Time (America/Buenos_Aires)',
    'America/Lima': '(GMT-05:00) Peru Standard Time (America/Lima)',
    'America/Bogota': '(GMT-05:00) Colombia Standard Time (America/Bogota)',
    'America/Caracas': '(GMT-04:00) Venezuela Standard Time (America/Caracas)',
    'America/Santiago': '(GMT-04:00) Chile Standard Time (America/Santiago)',
    'Africa/Cairo': '(GMT+02:00) Eastern European Time (Africa/Cairo)',
    'Africa/Johannesburg': '(GMT+02:00) South Africa Standard Time (Africa/Johannesburg)',
    'Africa/Lagos': '(GMT+01:00) West Africa Time (Africa/Lagos)',
    'Africa/Nairobi': '(GMT+03:00) East Africa Time (Africa/Nairobi)',
    'Africa/Casablanca': '(GMT+00:00) Western European Time (Africa/Casablanca)',
    'Africa/Tunis': '(GMT+01:00) Central European Time (Africa/Tunis)',
    'Africa/Algiers': '(GMT+01:00) Central European Time (Africa/Algiers)',
    'Africa/Tripoli': '(GMT+02:00) Eastern European Time (Africa/Tripoli)',
    'Africa/Khartoum': '(GMT+02:00) Eastern European Time (Africa/Khartoum)',
    'Africa/Addis_Ababa': '(GMT+03:00) East Africa Time (Africa/Addis_Ababa)',
    'Africa/Dar_es_Salaam': '(GMT+03:00) East Africa Time (Africa/Dar_es_Salaam)',
    'Africa/Kampala': '(GMT+03:00) East Africa Time (Africa/Kampala)',
    'Africa/Kigali': '(GMT+02:00) Central Africa Time (Africa/Kigali)',
    'Africa/Bujumbura': '(GMT+02:00) Central Africa Time (Africa/Bujumbura)',
    'Africa/Harare': '(GMT+02:00) Central Africa Time (Africa/Harare)',
    'Africa/Lusaka': '(GMT+02:00) Central Africa Time (Africa/Lusaka)',
    'Africa/Gaborone': '(GMT+02:00) Central Africa Time (Africa/Gaborone)',
    'Africa/Maseru': '(GMT+02:00) South Africa Standard Time (Africa/Maseru)',
    'Africa/Mbabane': '(GMT+02:00) South Africa Standard Time (Africa/Mbabane)',
    'Africa/Maputo': '(GMT+02:00) Central Africa Time (Africa/Maputo)',
    'Africa/Malabo': '(GMT+01:00) West Africa Time (Africa/Malabo)',
    'Africa/Douala': '(GMT+01:00) West Africa Time (Africa/Douala)',
    'Africa/Libreville': '(GMT+01:00) West Africa Time (Africa/Libreville)',
    'Africa/Brazzaville': '(GMT+01:00) West Africa Time (Africa/Brazzaville)',
    'Africa/Kinshasa': '(GMT+01:00) West Africa Time (Africa/Kinshasa)',
    'Africa/Bangui': '(GMT+01:00) West Africa Time (Africa/Bangui)',
    'Africa/Ndjamena': '(GMT+01:00) West Africa Time (Africa/Ndjamena)',
    'Africa/Porto-Novo': '(GMT+01:00) West Africa Time (Africa/Porto-Novo)',
    'Africa/Cotonou': '(GMT+01:00) West Africa Time (Africa/Cotonou)',
    'Africa/Lome': '(GMT+00:00) Greenwich Mean Time (Africa/Lome)',
    'Africa/Accra': '(GMT+00:00) Greenwich Mean Time (Africa/Accra)',
    'Africa/Abidjan': '(GMT+00:00) Greenwich Mean Time (Africa/Abidjan)',
    'Africa/Bamako': '(GMT+00:00) Greenwich Mean Time (Africa/Bamako)',
    'Africa/Ouagadougou': '(GMT+00:00) Greenwich Mean Time (Africa/Ouagadougou)',
    'Africa/Niamey': '(GMT+01:00) West Africa Time (Africa/Niamey)',
    'Africa/Nouakchott': '(GMT+00:00) Greenwich Mean Time (Africa/Nouakchott)',
    'Africa/Dakar': '(GMT+00:00) Greenwich Mean Time (Africa/Dakar)',
    'Africa/Banjul': '(GMT+00:00) Greenwich Mean Time (Africa/Banjul)',
    'Africa/Bissau': '(GMT+00:00) Greenwich Mean Time (Africa/Bissau)',
    'Africa/Conakry': '(GMT+00:00) Greenwich Mean Time (Africa/Conakry)',
    'Africa/Freetown': '(GMT+00:00) Greenwich Mean Time (Africa/Freetown)',
    'Africa/Monrovia': '(GMT+00:00) Greenwich Mean Time (Africa/Monrovia)',
    'Africa/Sao_Tome': '(GMT+00:00) Greenwich Mean Time (Africa/Sao_Tome)',
    'Australia/Sydney': '(GMT+10:00) Australian Eastern Standard Time (Australia/Sydney)',
    'Australia/Melbourne': '(GMT+10:00) Australian Eastern Standard Time (Australia/Melbourne)',
    'Australia/Brisbane': '(GMT+10:00) Australian Eastern Standard Time (Australia/Brisbane)',
    'Australia/Perth': '(GMT+08:00) Australian Western Standard Time (Australia/Perth)',
    'Australia/Adelaide': '(GMT+09:30) Australian Central Standard Time (Australia/Adelaide)',
    'Australia/Darwin': '(GMT+09:30) Australian Central Standard Time (Australia/Darwin)',
    'Australia/Hobart': '(GMT+10:00) Australian Eastern Standard Time (Australia/Hobart)',
    'Pacific/Auckland': '(GMT+12:00) New Zealand Standard Time (Pacific/Auckland)',
    'Pacific/Fiji': '(GMT+12:00) Fiji Time (Pacific/Fiji)',
    'Pacific/Guadalcanal': '(GMT+11:00) Solomon Islands Time (Pacific/Guadalcanal)',
    'Pacific/Port_Moresby': '(GMT+10:00) Papua New Guinea Time (Pacific/Port_Moresby)',
    'Pacific/Noumea': '(GMT+11:00) New Caledonia Time (Pacific/Noumea)',
    'Pacific/Efate': '(GMT+11:00) Vanuatu Time (Pacific/Efate)',
    'Pacific/Tongatapu': '(GMT+13:00) Tonga Time (Pacific/Tongatapu)',
    'Pacific/Chatham': '(GMT+12:45) Chatham Standard Time (Pacific/Chatham)',
    'Pacific/Kiritimati': '(GMT+14:00) Line Islands Time (Pacific/Kiritimati)',
    'Pacific/Honolulu': '(GMT-10:00) Hawaii Standard Time (Pacific/Honolulu)',
    'Pacific/Anchorage': '(GMT-09:00) Alaska Standard Time (America/Anchorage)',
    'Pacific/Palau': '(GMT+09:00) Palau Time (Pacific/Palau)',
    'Pacific/Chuuk': '(GMT+10:00) Chuuk Time (Pacific/Chuuk)',
    'Pacific/Funafuti': '(GMT+12:00) Tuvalu Time (Pacific/Funafuti)',
    'Pacific/Wallis': '(GMT+12:00) Wallis and Futuna Time (Pacific/Wallis)',
    'Indian/Maldives': '(GMT+05:00) Maldives Time (Indian/Maldives)',
    'Indian/Chagos': '(GMT+06:00) Indian Ocean Time (Indian/Chagos)',
    'Indian/Cocos': '(GMT+06:30) Cocos Islands Time (Indian/Cocos)',
    'Indian/Christmas': '(GMT+07:00) Christmas Island Time (Indian/Christmas)',
    'Indian/Comoro': '(GMT+03:00) East Africa Time (Indian/Comoro)',
    'Indian/Mayotte': '(GMT+03:00) East Africa Time (Indian/Mayotte)',
    'Indian/Mauritius': '(GMT+04:00) Mauritius Time (Indian/Mauritius)',
    'Indian/Reunion': '(GMT+04:00) Reunion Time (Indian/Reunion)',
    'Indian/Seychelles': '(GMT+04:00) Seychelles Time (Indian/Seychelles)',
    'Indian/Mahe': '(GMT+04:00) Seychelles Time (Indian/Mahe)'
  };

  /**
   * Convert timezone codes to full timezone names with GMT offset
   * @param timezoneCode - The timezone code (e.g., 'WAT', 'IST', 'CET', 'Asia/Kolkata')
   * @returns Full timezone name with GMT offset (e.g., '(GMT+01:00) West Africa Time (Africa/Lagos)')
   */
  convertTimezoneCodeToFullName(timezoneCode: string): string {
    return this.timezoneMapping[timezoneCode] || `(GMT+00:00) Coordinated Universal Time (${timezoneCode})`;
  }

  /**
   * Extract timezone from timezone string and convert to full timezone name
   * @param timezoneString - The timezone string (could be code or full format)
   * @returns Full timezone name with GMT offset
   */
  extractTimezoneFromString(timezoneString: string): string {
    // If it's already in the full format, return as is
    if (timezoneString.includes('GMT') && timezoneString.includes('(')) {
      return timezoneString;
    }
    
    // Extract timezone identifier from format like "(GMT+05:30) India Standard Time (Asia/Kolkata)"
    const match = timezoneString.match(/\(([^)]+)\)$/);
    const timezoneIdentifier = match ? match[1] : timezoneString;
    
    // Convert timezone identifier to full timezone name
    return this.convertTimezoneCodeToFullName(timezoneIdentifier);
  }

  /**
   * Get all available timezone codes
   * @returns Array of all timezone codes
   */
  getAllTimezoneCodes(): string[] {
    return Object.keys(this.timezoneMapping);
  }

  /**
   * Get all available timezone mappings
   * @returns Object with all timezone mappings
   */
  getAllTimezoneMappings(): { [key: string]: string } {
    return { ...this.timezoneMapping };
  }
}
